// extracted by mini-css-extract-plugin
export default {"root":"TourScheduleLayout_root__T-3ZX","left":"TourScheduleLayout_left__eUUxY","right":"TourScheduleLayout_right__JuQj8"};